module.exports = __webpack_public_path__ + "img/gear_six_grey.0595f91a.svg";